module.exports = __webpack_public_path__ + "img/Newbie_Axe_03_Classic.58f02fa8.png";